const BaseUrl: string = "https://ffapi.alialiev.com";
const auth: string = "/authenticated"
export const URLs = {
    GetCategories: BaseUrl + "/categories",
    AddCategory: BaseUrl + auth + "/categories",
    DelCategory: BaseUrl + auth + "/categories",

    GetOrders: BaseUrl + "/orders",
    AddOrder: BaseUrl + "/orders",
    DelOrder: BaseUrl + auth + "/orders",

    GetItems: BaseUrl + "/items",
    AddItem: BaseUrl + auth + "/items",
    DelItem: BaseUrl + auth + "/items",

    Login: BaseUrl + "/login"

};
